import { useMemo } from 'react'
import { useInView } from 'react-intersection-observer'

import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

import { hasMapCoordinates } from './mapCoordinates'
import OfferPropertySurroundings from './OfferPropertySurroundings'

interface Props {
  offerId: string | undefined
  latitude: number | undefined
  longitude: number | undefined
}

function OfferPropertySurroundingsActivationWrapper({
  offerId,
  latitude,
  longitude,
}: Props) {
  const coordinates = useMemo(() => ({ latitude, longitude }), [latitude, longitude])
  const hasRequiredParams = !!offerId && hasMapCoordinates(coordinates)
  const [activationRef, hasMapBeenInView] = useInView({
    triggerOnce: true,
  })
  const { isAnyVariant: shouldShowSurroundings } = useExperiment(
    Experiments.croOfferNearbyLocations,
    { canActivate: hasRequiredParams && hasMapBeenInView },
  )

  if (!hasRequiredParams || !offerId || latitude === undefined || longitude === undefined) {
    return null
  }

  return (
    <div ref={activationRef}>
      {shouldShowSurroundings && (
        <OfferPropertySurroundings
          offerId={offerId}
          latitude={latitude}
          longitude={longitude}
        />
      )}
    </div>
  )
}

export default OfferPropertySurroundingsActivationWrapper
